import { Application } from "Application";
import * as Topics from "Data/Topics";
import { Sine } from "gsap/EasePack";
import { TweenLite } from "gsap/TweenLite";

import * as HLF from "html-living-framework";

export class Button extends HLF.Button {
    protected static readonly SCALE_NORMAL: number = 1.0;
    protected static readonly SCALE_OVER: number = 1.05;
    protected static readonly SCALE_DOWN: number = 0.95;

    protected _hoverVO: string | undefined;
    protected _clickedSFX: string | undefined;

    constructor(
        pCallback: () => void,
        pAsset: string,
        pSheet?: string | string[],
        pHoverVO?: string,
        pClickedSFX?: string,
    ) {
        super(pCallback, pAsset, pSheet);

        this._hoverVO = pHoverVO;
        this._clickedSFX = pClickedSFX;
    }

    public onFocusBegin(): void {
        super.onFocusBegin();
        this.playHoverVO();
    }

    public onFocusActivated(): void {
        if (this.interactive) {
            this.playClickedSFX();
            PubSub.publishSync(Topics.RESTART_IDLE_TIMER, undefined);
        }
        super.onFocusActivated();
    }

    public getOnboardingPosition(): PIXI.Point {
        return this.getGlobalPosition();
    }

    public getOnboardingRotation(): number {
        return 0;
    }

    protected onPointerOver(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerOver(pEvent);
        TweenLite.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_OVER,
            y: Button.SCALE_OVER,
            ease: Sine.easeInOut,
        });
        this.playHoverVO();
    }

    protected onPointerDown(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerDown(pEvent);
        TweenLite.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_DOWN,
            y: Button.SCALE_DOWN,
            ease: Sine.easeInOut,
        });
    }

    protected onPointerUp(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._eventData !== undefined) {
            TweenLite.to(this._visuals.scale, 0.15, {
                x: Button.SCALE_OVER,
                y: Button.SCALE_OVER,
                ease: Sine.easeInOut,
            });
            this.playClickedSFX();
        }
        super.onPointerUp(pEvent);
    }

    protected onPointerOut(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerOut(pEvent);
        TweenLite.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_NORMAL,
            y: Button.SCALE_NORMAL,
            ease: Sine.easeInOut,
        });
    }

    protected playHoverVO(): void {
        if (this._hoverVO !== undefined) {
            Application.instance.voiceover.playVO(this._hoverVO, {
                priority: -1,
                mode: HLF.PlayMode.Override,
            });
            PubSub.publishSync(Topics.RESTART_IDLE_TIMER, undefined);
        }
    }

    protected playClickedSFX(): void {
        if (this._clickedSFX !== undefined) {
            PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(this._clickedSFX, 1, false, HLF.AudioCategory.SFX));
        }
    }
}
